// Same shape as admin/src/utils/formatDate.js — see that file's own header
// comment for the full CLAUDE.md reasoning (UTC storage, EAT display via
// Intl.DateTimeFormat). Not moved to shared/ (out of scope for this task);
// a small, independent copy here, same as several other small portal-local
// utilities in this app.

const EAT_TIME_ZONE = 'Africa/Addis_Ababa';

function formatter(lang, options) {
  return new Intl.DateTimeFormat(lang === 'am' ? 'am-ET' : 'en-ET', {
    timeZone: EAT_TIME_ZONE,
    ...options,
  });
}

export function formatDate(isoString, lang = 'en') {
  if (!isoString) return null;
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return null;
  return formatter(lang, { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
}

export function formatDateTime(isoString, lang = 'en') {
  if (!isoString) return null;
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return null;
  return formatter(lang, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export default formatDate;
